import React from 'react'
import { history } from '../helpers'
import { Sidebar, Segment, Icon, Divider } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { PanelTop } from './PanelPages'
import { UserActions } from '../actions'
import { connect } from 'react-redux';
export default class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const { dispatch } = this.props;
        dispatch(UserActions.logout());
        history.push('/');
    }

    state ={visible:false, activeIndex: -1,tagOptions: [
  {
    text: 'Important',
    value: 'Important',
  },
]}
    toggleVisibility = () => this.setState({visible: !this.state.visible})
    
    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }
    
    render() {

        return (
            <div className='home-page'>
                <PanelTop>
                    <li style={{display:'flex'}}> <button className="icon-button" onClick={this.toggleVisibility}>
                        <i className="sidebar big icon inverted"></i>
                    </button>
                    </li>
                    <li className='Selector' onClick={this.handleChange}>Çıkış</li>
                        </PanelTop>
            
                <Sidebar.Pushable style={{ minHeight: '-webkit-fill-available ', maxHeight:'100%'}}>
                <Sidebar  animation='push' width='thin' visible={this.state.visible} icon='labeled' style={{width: 'auto'}} >
                    <div className="page-left"  >
                        <Divider hidden />
                        <ul >
                            {this.props.userType === 'instructor' &&
                            <span>
                                <li>
                                    <Link 
                                        className='page-left-item' 
                                        to='/' 
                                        onClick={this.toggleVisibility}>  
                                        <i><Icon name='wizard' /></i>
                                        Surucu Olustur 
                                    </Link>       
                                </li>
                                <Divider />
                            </span>
                                
                            }
                            {(this.props.userType === 'm1' || this.props.userType === 'm2' || this.props.userType === 'admin') &&
                            <span>
                                <li> 
                                    <Link 
                                        className='page-left-item' 
                                        to='/Drivers' 
                                        onClick={this.toggleVisibility}>  
                                        <i><Icon name='user' /></i>
                                        Suruculer 
                                    </Link>
                                </li>
                                <Divider/>
                                <li> 
                                    <Link 
                                        to='/Sertifikalar' 
                                        className='page-left-item' 
                                        onClick={this.toggleVisibility}>
                                        <i><Icon name='drivers license' /></i>
                                        Sertifikalar
                                    </Link>  
                                </li>
                                <Divider/>
                            </span> 
                            }
                            {this.props.userType === 'instructor' &&
                                <span>
                                    <li>
                                        <Link 
                                            to='/Egitimler' 
                                            className='page-left-item' 
                                            onClick={this.toggleVisibility}>
                                            <i className= 'ignore-css'>
                                                <Icon  name='student' />
                                            </i>
                                            Egitimler
                                        </Link>
                                    </li>
                                    <Divider/>
                                </span>
                            }
                            {this.props.userType === 'admin' &&
                            <li>
                                <Link 
                                    to='/Onay' 
                                    className='page-left-item' 
                                    onClick={this.toggleVisibility}>
                                    <i className='ignore-css'>
                                        <Icon name='checkmark' />
                                    </i>
                                    Onay Bekleyenler
                                </Link>
                            </li>
                            }

                        </ul>
                    </div>

                </Sidebar>
                <Sidebar.Pusher>
                    <Segment basic style= {{marginLeft: '20px', maxWidth: '1600px'}}>
                        {this.props.children}
                    </Segment>
                </Sidebar.Pusher>
            </Sidebar.Pushable>
        </div>
        

        );
    }

}

function mapStateToProps(state) {
return{};
}
const connectedHomePage = connect(mapStateToProps, null, null, {
  pure: false
})(Navbar);
export { connectedHomePage as Navbar };






// WEBPACK FOOTER //
// ./src/components/Panel.jsx